import { render, staticRenderFns } from "./more-details.vue?vue&type=template&id=79645818&"
import script from "./more-details.vue?vue&type=script&lang=js&"
export * from "./more-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports